/**
 * Company: SPHMedia
 * Description: [Gets Omny podcast data]
 */

import fetchBHApi from "@helper/fetchBHApi";
import { useEffect, useState } from "react";

import { PodcastProcessedResponse } from "./transformer/usePodcastResponse";

type useOmnyPodcastData = {
  playing: PodcastProcessedResponse | undefined;
};

/**
 * Custom React Hook: useOmnyPodcast
 * Description: [Gets podcasts from omny]
 * @returns data - The data returned by the hook
 */
export default function useOmnyPodcast(): useOmnyPodcastData {
  const [playing, setPlaying] = useState<PodcastProcessedResponse>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const podcasts: PodcastProcessedResponse[] = await fetchBHApi<
          PodcastProcessedResponse[]
        >("podcasts?size=1", "GET");
        const limitedContent = podcasts[0];
        setPlaying(limitedContent);
      } catch (error) {
        console.error("[InfiniteScroll] Error fetching omny podcast:", error);
      }
    };
    void fetchData();
  }, []);

  return { playing };
}
